import { useMutation } from '@tanstack/react-query';
import { clientsApi } from '@/api/waterlily';
import type { API } from '@/api/types';

export function useShareClientWithSupervisors(clientId: string) {
  const mutation = useMutation({
    mutationFn: (data: API.ShareClientRequest) => clientsApi.shareWithSupervisors(clientId, data),
  });

  return {
    shareWithSupervisors: mutation.mutate,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
}
